import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * @description Render memoized perfect addtions template
 * @param {Object} props
 * @returns {JSX.Element} Memoized perfect addtions template
 */
export const PerfectAdditions = memo(function MemoizedPerfectAdditions(props) {
  const { items = null } = props;
  const sliderSettings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 748,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };

  return (
    <div>
      <p className="text-center text-base font-normal tracking-widest text-black md:text-left">PERFECT ADDITIONS</p>

      {items && Array.isArray(items) && items?.length > 0 ? (
        <div className="my-6 flex w-full items-center gap-2">
          <Slider {...sliderSettings1} className="w-full">
            {items.map(({ node: { bigcommerce_id = null, image_url = '#', name = '', custom_url } }, index) => {
              return (
                <div key={bigcommerce_id || index} className="relative h-32 pr-2 md:h-48">
                  <Link to={custom_url?.url}>
                    {typeof image_url === 'string' && image_url?.length > 0 ? (
                      <img src={image_url} alt={name} className="h-full object-cover" loading="lazy" />
                    ) : null}

                    <div className="absolute bottom-0 left-0 px-4 py-2 text-white">
                      <p className="m-0 text-xs font-normal">SHOP</p>

                      {typeof name === 'string' && name?.length > 0 ? (
                        <p className="m-0 text-sm font-normal uppercase md:text-lg ">{name}</p>
                      ) : null}
                    </div>
                  </Link>
                </div>
              );
            })}
          </Slider>
        </div>
      ) : null}
    </div>
  );
});

PerfectAdditions.propTypes = {
  items: PropTypes.array
};
